
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12.25","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 167","fill":"#b1b6b9"}},[_c('path',{attrs:{"data-name":"Exclusion 1","d":"M4.193 7l5.976-3.415v6.829L4.195 7z"}}),_c('path',{attrs:{"data-name":"Path 607 - Outline","d":"M2.351 7l8.732 4.99V2.01L2.351 7M0 7l12.25-7v14z"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/network_module/hierarchy-treeview/closure_splice.svg